export default "__VITE_ASSET__B61i5jfp__"